import React from 'react';

export default ({ children, numTiles }) => (
    <div
        css={{
            display: 'grid',
            gridTemplateColumns: numTiles === 4 ? '212px 212px' : '212px 212px 212px',
            gridTemplateRows: '248px 248px',
            gridGap: 32,
            margin: '0 auto',
            justifyContent: 'center',
            '@media(max-width: 767px)': {
                gridGap: 20,
                gridTemplateColumns: '212px 212px',
            },
            '@media(max-width: 479px)': {
                gridTemplateColumns: '212px',
            }
        }}
    >
        {children}
    </div>
);
